import { apiClient } from '../api/client'
import { AuthResponse, LoginCredentials, RegisterData, User } from './types'

export class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/auth/login', credentials)
    if (response.success && response.data.token) {
      apiClient.setAuthToken(response.data.token)
    }
    return response
  }

  async register(data: RegisterData): Promise<AuthResponse> {
    const { confirmPassword: _confirmPassword, ...registrationData } = data as RegisterData & { confirmPassword?: string }
    const response = await apiClient.post<AuthResponse>('/api/auth/register', registrationData)
    if (response.success && response.data.token) {
      apiClient.setAuthToken(response.data.token)
    }
    return response
  }

  async logout(): Promise<void> {
    try {
      await apiClient.post('/api/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      apiClient.clearAuthToken()
      localStorage.removeItem('user')
    }
  }

  async verifyToken(): Promise<{ success: boolean; data: { user: User } }> {
    return apiClient.post('/api/auth/verify')
  }

  async getProfile(): Promise<{ success: boolean; data: User }> {
    return apiClient.get('/api/auth/profile')
  }

  async refreshToken(): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/api/auth/refresh')
    if (response.success && response.data.token) {
      apiClient.setAuthToken(response.data.token)
    }
    return response
  }
}

export const authService = new AuthService()